export default __webpack_public_path__ + "static/media/naidi-2-3.52a46d4c.svg";